import { getToken, isSupported } from "firebase/messaging";
import { messaging, VAPID_KEY } from "./firebaseConfig";

const SW_PATH = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js`;

export async function setupPushNotifications() {
  try {
    if (!VAPID_KEY) {
      console.warn("Push notifications skipped: missing VAPID key.");
      return null;
    }

    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      return null;
    }

    const messagingSupported = await isSupported();
    if (!messagingSupported) {
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }

    const registration = await navigator.serviceWorker.register(SW_PATH);
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      localStorage.setItem("fcm", token);
    }

    return token || null;
  } catch (error) {
    console.warn("Push notification setup failed:", error?.message || error);
    return null;
  }
}
